export const translations = {
  es: {
    nav: {
      services: "Servicios",
      "work-together": "Trabajemos",
      experience: "Experiencia",
      methodology: "Cómo trabajo",
      contact: "Contacto",
      cta: "Agendar sesión"
    },
    hero: {
      headline: "Estrategia para crecer con claridad y resultados",
      subheadline: "Ayudo a empresas a crecer, monetizar y escalar con estrategias comerciales y de marketing diseñadas para generar resultados reales.",
      credibility: "+25 años | USD 11M gestionados | +COP 2.000M en ingresos generados",
      cta: "Quiero una sesión estratégica",
      secondary: "Ver cómo trabajo"
    },
    targetClient: {
      title: "Trabajo con empresas que…",
      items: [
        "Facturan pero no escalan — el crecimiento está estancado",
        "Invierten en marketing sin retorno claro ni medible",
        "No tienen una estrategia comercial estructurada",
        "Dependen del día a día y no logran salir de la operación",
        "Saben que pueden crecer más, pero no saben cómo"
      ],
      closing: "Si te identificas con alguno de estos puntos, podemos trabajar juntos."
    },
    industries: {
      title: "Industrias donde construimos crecimiento",
      items: [
        {
          name: "Gastronomía & Hospitalidad",
          desc: "Restaurantes, bares, conceptos nocturnos y hoteles que buscan crecer estratégicamente."
        },
        {
          name: "Entretenimiento & Música",
          desc: "Artistas, sellos, productoras y venues que necesitan estructura para monetizar su creatividad."
        },
        {
          name: "Servicios B2B",
          desc: "Empresas de servicios que quieren pasar del crecimiento por referidos a un modelo comercial predecible."
        },
        {
          name: "Marcas con identidad propia",
          desc: "Negocios donde el fundador es la marca y necesita traducir su visión en posicionamiento."
        }
      ]
    },
    problem: {
      title: "El problema no es que trabajes poco.",
      subtitle: "Es que no tienes una estrategia que funcione.",
      text: "La mayoría de empresas que me buscan están haciendo muchas cosas, pero sin claridad. Marketing sin dirección. Ventas sin sistema. Crecimiento sin estructura.",
      differentiator: "Yo no arreglo tácticas. Construyo máquinas de crecimiento."
    },
    services: {
      title: "Servicios",
      subtitle: "Lo que hago por tu negocio",
      items: [
        {
          title: "Diagnóstico Estratégico",
          desc: "Analizamos tu modelo comercial, marca y oportunidades. Entregamos claridad en días, no meses."
        },
        {
          title: "Estrategia de Crecimiento",
          desc: "Defino qué vender, a quién, cómo y a qué precio. Diseño el sistema que convierte tu operación en ingresos predecibles."
        },
        {
          title: "Plan de Lanzamiento",
          desc: "Para un producto, negocio, álbum o evento. Plan completo con fases, canales, mensajes clave y ejecución acompañada."
        },
        {
          title: "Estrategia de Marketing",
          desc: "Nada de branding vacío. Marketing que se mide, que convierte y que impacta la caja."
        },
        {
          title: "Acompañamiento Estratégico",
          desc: "Sesiones quincenales + seguimiento de indicadores + ajustes de plan. Eres mi cliente, no mi proyecto."
        }
      ]
    },
    session: {
      label: "Oferta de entrada",
      title: "Sesión Estratégica 1:1",
      subtitle: "90 minutos que pueden cambiar tu negocio",
      description: "Una sesión conmigo donde analizamos tu situación actual, identificamos los bloqueos de crecimiento y definimos las 3 palancas más importantes para escalar tu negocio en los próximos 6 meses.",
      includes: [
        "Diagnóstico de tu modelo de negocio actual",
        "Identificación de oportunidades de revenue ocultas",
        "Plan de acción con prioridades claras",
        "Grabación de la sesión para que la revises"
      ],
      cta: "Reservar mi sesión estratégica",
      note: "Trabajo con un número limitado de empresas al mismo tiempo."
    },
    authority: {
      title: "No es teoría. Es experiencia real.",
      subtitle: "He liderado crecimiento en industrias donde los resultados se miden en millones.",
      items: [
        { 
          number: "+25", 
          label: "años", 
          desc: "construyendo crecimiento comercial" 
        },
        { 
          number: "USD 11M", 
          label: "en presupuesto", 
          desc: "bajo mi responsabilidad directa" 
        },
        { 
          number: "+COP 2.000M", 
          label: "generados", 
          desc: "en ingresos incrementales" 
        },
        { 
          number: "4", 
          label: "industrias", 
          desc: "fitness, medios, deportes, hospitalidad" 
        }
      ]
    },
    experience: {
      title: "Lo que hemos construido",
      subtitle: "Resultados reales en negocios reales",
      items: [
        {
          industry: "Servicios B2B",
          company: "LIMA · Medellín",
          impact: "Diagnóstico estratégico-comercial completo. Identificación de arquitectura de crecimiento, sectores prioritarios y roadmap a 90 días.",
          result: "Presentación ejecutiva a Gerencia General con 3 decisiones accionables. Herramienta de inteligencia de mercado en despliegue."
        },
        {
          industry: "Gastronomía & Entretenimiento",
          company: "La Comitiva · Cali",
          impact: "Sistema de crecimiento para tres conceptos: La Comitiva, Flores y Lechugas, y Nocturno. Estrategia de revenue y posicionamiento 2026.",
          result: "Plan de +$120MM/año en nuevas líneas de ingreso. Lanzamiento de La Comitiva Nocturno en Junio 2026."
        },
        {
          industry: "Deportes",
          company: "DIM · Medellín",
          impact: "Estrategia comercial integral para el club. Desarrollo de patrocinios y alianzas estratégicas de largo plazo.",
          result: "+COP 2.000M en ingresos incrementales. Patrocinios de largo plazo cerrados."
        },
        {
          industry: "Fitness & Wellness",
          company: "Smart Fit & Bio Ritmo",
          impact: "Estrategia de crecimiento para +40 sedes. Liderazgo de marketing y expansión a nuevos mercados.",
          result: "+800 usuarios en 5 meses en nuevo mercado (Panamá)."
        }
      ]
    },
    methodology: {
      title: "Así trabajo",
      subtitle: "Sin vueltas. Directo a resultados.",
      steps: [
        {
          number: "01",
          title: "Diagnóstico amplio",
          desc: "Entiendo tu negocio sin filtros. Qué funciona, qué no, y por qué no estás creciendo."
        },
        {
          number: "02",
          title: "Estrategia accionable",
          desc: "No entrego documentos bonitos. Entrego un plan que puedes ejecutar mañana."
        },
        {
          number: "03",
          title: "Prioridades claras",
          desc: "Te digo exactamente qué hacer primero, segundo y tercero. Sin confusión."
        },
        {
          number: "04",
          title: "Acompañamiento real",
          desc: "No te dejo solo con un PDF. Estoy contigo hasta que los resultados lleguen."
        }
      ]
    },
    scarcity: {
      text: "Trabajo con un número limitado de empresas al mismo tiempo para garantizar resultados."
    },
    workTogether: {
      title: "Cómo podemos trabajar juntos",
      scarcity: "Trabajo con un número limitado de empresas al mismo tiempo para asegurar impacto real.",
      tiers: [
        {
          label: "Punto de entrada",
          title: "Sesión estratégica",
          description: "Una sesión de alto nivel donde analizamos tu negocio, identificamos oportunidades de crecimiento y definimos acciones concretas para generar ingresos.",
          includes: [
            "Diagnóstico de tu modelo actual",
            "Identificación de oportunidades de crecimiento",
            "Recomendaciones claras y accionables"
          ],
          duration: "90 minutos",
          price: "Desde $1.200.000 COP",
          cta: "Agendar sesión",
          highlighted: false
        },
        {
          label: "Más solicitado",
          title: "Plan de crecimiento y monetización",
          description: "Diseño la estrategia completa para hacer crecer tu negocio de forma estructurada, rentable y sostenible.",
          includes: [
            "Diagnóstico profundo del negocio",
            "Estrategia de crecimiento y monetización",
            "Definición de pricing y go-to-market",
            "Plan de acción claro"
          ],
          duration: "4 a 6 semanas",
          price: "Desde $6.000.000 COP",
          cta: "Solicitar propuesta",
          highlighted: true
        },
        {
          label: "Premium",
          title: "Acompañamiento estratégico",
          description: "Acompaño la implementación de la estrategia para asegurar resultados reales y sostenibles en el tiempo.",
          includes: [
            "Seguimiento estratégico mensual",
            "Ajustes y decisiones clave",
            "Sesiones periódicas",
            "Comunicación directa"
          ],
          duration: "Continuo",
          price: "Desde $3.000.000 COP / mes",
          cta: "Hablemos",
          highlighted: false
        }
      ]
    },
    cta: {
      title: "¿Listo para dejar de improvisar?",
      subtitle: "Una conversación puede ser el punto de inflexión de tu negocio.",
      text: "No esperes a que el mercado te obligue a cambiar. Actúa ahora.",
      primary: "Agendar mi sesión estratégica",
      whatsapp: "Escribir por WhatsApp ahora"
    },
    contact: {
      title: "Contacto",
      subtitle: "El primer paso es simple",
      form: {
        name: "Tu nombre",
        email: "Tu email",
        company: "Tu empresa",
        message: "¿Cuál es tu mayor bloqueo de crecimiento ahora mismo?",
        submit: "Enviar mensaje",
        success: "Mensaje enviado. Te contactaré en menos de 24 horas.",
        error: "Error al enviar. Intenta de nuevo."
      }
    },
    footer: {
      tagline: "Estrategia comercial de alto nivel",
      rights: "Todos los derechos reservados"
    }
  },
  en: {
    nav: {
      services: "Services",
      "work-together": "Work Together",
      experience: "Experience",
      methodology: "How I work",
      contact: "Contact",
      cta: "Book session"
    },
    hero: {
      headline: "Strategy to grow with clarity and results",
      subheadline: "I help companies grow, monetize, and scale with commercial and marketing strategies designed to generate real results.",
      credibility: "+25 years | USD 11M managed | +COP 2,000M in revenue generated",
      cta: "I want a strategic session",
      secondary: "See how I work"
    },
    targetClient: {
      title: "I work with companies that…",
      items: [
        "Are billing but not scaling — growth is stagnant",
        "Invest in marketing without clear or measurable ROI",
        "Don't have a structured commercial strategy",
        "Are stuck in day-to-day operations and can't get out",
        "Know they can grow more, but don't know how"
      ],
      closing: "If you identify with any of these, we can work together."
    },
    industries: {
      title: "Industries where we build growth",
      items: [
        {
          name: "Gastronomy & Hospitality",
          desc: "Restaurants, bars, nightlife concepts, and hotels looking to grow strategically."
        },
        {
          name: "Entertainment & Music",
          desc: "Artists, labels, production companies, and venues needing structure to monetize their creativity."
        },
        {
          name: "B2B Services",
          desc: "Service companies aiming to move beyond referral-based growth to a predictable commercial model."
        },
        {
          name: "Brands with their own identity",
          desc: "Businesses where the founder is the brand and needs to translate their vision into positioning."
        }
      ]
    },
    problem: {
      title: "The problem isn't that you're not working hard.",
      subtitle: "It's that you don't have a strategy that works.",
      text: "Most companies that come to me are doing many things, but without clarity. Marketing without direction. Sales without a system. Growth without structure.",
      differentiator: "I don't fix tactics. I build growth machines."
    },
    services: {
      title: "Services",
      subtitle: "What I do for your business",
      items: [
        {
          title: "Strategic Diagnosis",
          desc: "We analyze your commercial model, brand, and opportunities. We deliver clarity in days, not months."
        },
        {
          title: "Growth Strategy",
          desc: "I define what to sell, to whom, how, and at what price. I design the system that turns your operation into predictable revenue."
        },
        {
          title: "Launch Plan",
          desc: "For a product, business, album, or event. Complete plan with phases, channels, key messages, and accompanied execution."
        },
        {
          title: "Marketing Strategy",
          desc: "No empty branding. Marketing that's measured, converts, and impacts the bottom line."
        },
        {
          title: "Strategic Advisory",
          desc: "Bi-weekly sessions + indicator tracking + plan adjustments. You are my client, not my project."
        }
      ]
    },
    session: {
      label: "Entry offer",
      title: "1:1 Strategic Session",
      subtitle: "90 minutes that can change your business",
      description: "A session with me where we analyze your current situation, identify growth blockers, and define the 3 most important levers to scale your business in the next 6 months.",
      includes: [
        "Diagnosis of your current business model",
        "Identification of hidden revenue opportunities",
        "Action plan with clear priorities",
        "Session recording for you to review"
      ],
      cta: "Book my strategic session",
      note: "I work with a limited number of companies at a time."
    },
    authority: {
      title: "This isn't theory. It's real experience.",
      subtitle: "I've led growth in industries where results are measured in millions.",
      items: [
        { 
          number: "+25", 
          label: "years", 
          desc: "building commercial growth" 
        },
        { 
          number: "USD 11M", 
          label: "in budget", 
          desc: "under my direct responsibility" 
        },
        { 
          number: "+COP 2,000M", 
          label: "generated", 
          desc: "in incremental revenue" 
        },
        { 
          number: "4", 
          label: "industries", 
          desc: "fitness, media, sports, hospitality" 
        }
      ]
    },
    experience: {
      title: "What we have built",
      subtitle: "Real results in real businesses",
      items: [
        {
          industry: "B2B Services",
          company: "LIMA · Medellín",
          impact: "Complete strategic-commercial diagnosis. Growth architecture identification, priority sectors, and 90-day roadmap.",
          result: "Executive presentation to General Management with 3 actionable decisions. Market intelligence tool in deployment."
        },
        {
          industry: "Gastronomy & Entertainment",
          company: "La Comitiva · Cali",
          impact: "Growth system for three concepts: La Comitiva, Flores y Lechugas, and Nocturno. Revenue and positioning strategy for 2026.",
          result: "Plan for +$120MM/year in new revenue streams. La Comitiva Nocturno launch in June 2026."
        },
        {
          industry: "Sports",
          company: "DIM · Medellín",
          impact: "Comprehensive commercial strategy for the club. Development of long-term sponsorships and strategic alliances.",
          result: "+COP 2,000M in incremental revenue. Long-term sponsorships closed."
        },
        {
          industry: "Fitness & Wellness",
          company: "Smart Fit & Bio Ritmo",
          impact: "Growth strategy for 40+ locations. Marketing leadership and expansion into new markets.",
          result: "+800 users in 5 months in new market (Panama)."
        }
      ]
    },
    methodology: {
      title: "How I work",
      subtitle: "No fluff. Straight to results.",
      steps: [
        {
          number: "01",
          title: "Comprehensive diagnosis",
          desc: "I understand your business without filters. What works, what doesn't, and why you're not growing."
        },
        {
          number: "02",
          title: "Actionable strategy",
          desc: "I don't deliver pretty documents. I deliver a plan you can execute tomorrow."
        },
        {
          number: "03",
          title: "Clear priorities",
          desc: "I tell you exactly what to do first, second, and third. No confusion."
        },
        {
          number: "04",
          title: "Real support",
          desc: "I don't leave you alone with a PDF. I'm with you until results arrive."
        }
      ]
    },
    scarcity: {
      text: "I work with a limited number of companies at a time to guarantee results."
    },
    workTogether: {
      title: "How we can work together",
      scarcity: "I work with a limited number of companies at a time to ensure real impact.",
      tiers: [
        {
          label: "Entry point",
          title: "Strategic session",
          description: "A high-level session where we analyze your business, identify growth opportunities, and define concrete actions to generate revenue.",
          includes: [
            "Diagnosis of your current model",
            "Identification of growth opportunities",
            "Clear and actionable recommendations"
          ],
          duration: "90 minutes",
          price: "From $1,200,000 COP",
          cta: "Book session",
          highlighted: false
        },
        {
          label: "Most requested",
          title: "Growth & monetization plan",
          description: "I design the complete strategy to grow your business in a structured, profitable, and sustainable way.",
          includes: [
            "Deep business diagnosis",
            "Growth and monetization strategy",
            "Pricing and go-to-market definition",
            "Clear action plan"
          ],
          duration: "4 to 6 weeks",
          price: "From $6,000,000 COP",
          cta: "Request proposal",
          highlighted: true
        },
        {
          label: "Premium",
          title: "Strategic advisory",
          description: "I accompany the strategy implementation to ensure real and sustainable results over time.",
          includes: [
            "Monthly strategic follow-up",
            "Key adjustments and decisions",
            "Periodic sessions",
            "Direct communication"
          ],
          duration: "Ongoing",
          price: "From $3,000,000 COP / month",
          cta: "Let's talk",
          highlighted: false
        }
      ]
    },
    cta: {
      title: "Ready to stop improvising?",
      subtitle: "One conversation can be the turning point for your business.",
      text: "Don't wait for the market to force you to change. Act now.",
      primary: "Book my strategic session",
      whatsapp: "Message on WhatsApp now"
    },
    contact: {
      title: "Contact",
      subtitle: "The first step is simple",
      form: {
        name: "Your name",
        email: "Your email",
        company: "Your company",
        message: "What's your biggest growth blocker right now?",
        submit: "Send message",
        success: "Message sent. I'll contact you within 24 hours.",
        error: "Error sending. Please try again."
      }
    },
    footer: {
      tagline: "High-level commercial strategy",
      rights: "All rights reserved"
    }
  }
};
